import { useEffect } from "react";

const DEFAULT_TITLE = "Luminary Insights & Advisory — Strategic Intelligence for High-Growth Industries";
const DEFAULT_DESC = "Luminary is a strategic intelligence and advisory firm built for boards and capital allocators. 14 industries · 15 modules · 7 frameworks · 12 trackers · Luminous AI briefs.";

function setMeta(name, content) {
  if (!content) return;
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setProp(prop, content) {
  if (!content) return;
  let el = document.querySelector(`meta[property="${prop}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("property", prop);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Lightweight head manager — sets <title>, meta description, OG tags.
 * No react-helmet dependency; mutates document.head directly.
 *
 * @param {{ title?:string, description?:string, image?:string, path?:string, keywords?:string }} meta
 */
export default function usePageMeta(meta = {}) {
  useEffect(() => {
    const title = meta.title || DEFAULT_TITLE;
    const description = (meta.description || DEFAULT_DESC).slice(0, 160);
    document.title = title;
    setMeta("description", description);
    if (meta.keywords) setMeta("keywords", meta.keywords);
    setProp("og:title", title);
    setProp("og:description", description);
    setProp("og:type", "website");
    setProp("og:site_name", "Luminary Insights & Advisory");
    if (meta.image) setProp("og:image", meta.image);
    if (meta.path && typeof window !== "undefined") {
      setProp("og:url", `${window.location.origin}${meta.path}`);
    }
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    return () => { /* leave tags in place for the next page to overwrite */ };
  }, [meta.title, meta.description, meta.image, meta.path, meta.keywords]);
}
